  /**
   * Fetches search parameters by first obtaining an authentication token
   * and then using the token to call the search parameters API
   *
   * @param {Object} config - Configuration object
   * @param {string} config.tokenApiUrl - URL for obtaining the access token
   * @param {string} config.apiBaseUrl - Base URL for the search parameters API
   * @param {string} config.clientId - Client ID for authentication
   * @param {string} config.clientSecret - Client secret for authentication
   * @param {string} config.scope - Scope for the token request
   * @param {string} config.sessionId - Session ID for the search parameters request
   * @param {string} config.optionId - Option ID for the search parameters request (can be empty)
   * @returns {Promise<Object>} - Promise resolving to the search parameters data
   */

  export const fetchBookingBotData = async (config) => {
    const {
      tokenApiUrl,
      apiBaseUrl,
      clientId,
      clientSecret,
      scope,
      sessionId,
      optionId = "",
    } = config

    try {
      // Step 1: Obtain Access Token
      const tokenResponse = await fetch(tokenApiUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: `grant_type=client_credentials&client_id=${clientId}&client_secret=${clientSecret}&scope=${scope}`,
      })

      if (!tokenResponse.ok) {
        const errorData = await tokenResponse.json()
        throw new Error(
          `Failed to obtain access token: ${JSON.stringify(errorData)}`
        )
      }

      const tokenData = await tokenResponse.json()
      const accessToken = tokenData.access_token

      // Step 2: Fetch Search Parameters
      const searchParamsUrl = `${apiBaseUrl}/get-booking-search-params`

      
      const searchParamsResponse = await fetch(searchParamsUrl, {
        method: "POST",
        headers: {
          "Authorization": `Bearer ${accessToken}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          session_id: sessionId,
          option_id: optionId,
        }),
      })

      if (!searchParamsResponse.ok) {
        const errorData = await searchParamsResponse.json()
        throw new Error(
          `Failed to fetch search parameters: ${JSON.stringify(errorData)}`
        )
      }

      return await searchParamsResponse.json()
      
      //return {
      //  "statusCode": 200,
      //  "body": "{\"status\": 200, \"message\": \"\", \"data\": {\"selected_option\": \"\", \"source_message_id\": \"06339094\", \"source_thread_id\": \"500O300000K1umDIAR\", \"extracted_data\": {\"Departure Date\": \"2025-03-20\", \"Return Date\": \"2025-03-23\", \"Origin Location\": \"DEL\", \"Destination Location\": \"HYD\", \"traveller_id\": \"\", \"cabin_class\": \"Y\"}, \"missing_data\": \"\", \"session_id\": \"a4a6a133b01f71f580292683\", \"recommended_flights\": [\"AI.544.DEL.HYD|AI.2559.HYD.DEL\", \"AI.2577.DEL.HYD|AI.2559.HYD.DEL\", \"AI.2899.DEL.HYD|AI.2559.HYD.DEL\", \"AI.2879.DEL.HYD|AI.2559.HYD.DEL\"], \"booking_type\": [\"round_trip\"], \"number_of_clicks\": 7}}"
      //}


    } catch (error) {
      console.error("Error in fetchBookingBotData:", error)
      throw error
    }
  }
